<template>
  <div style="width: 100%">
    <div class="group-header handle">
      <div class="group-header-box">
        <span style="font-size: 30px"><BIconJustify /></span>
        <span>{{ group.name }}</span>
        <span>
          <b-button
            v-b-tooltip.hover
            :title="'edit' | i18n"
            class="edit-btn close float-none"
            aria-label="Close"
            variant="light"
            @click="editGroupName(group)"
          >
            <img :src="editIcon" height="18" alt="edit_icon">
          </b-button>
          <b-button
            v-b-tooltip.hover
            :title="'duplicate_topic' | i18n"
            class="edit-btn close float-none"
            variant="light"
            @click="duplicateGroup(group)"
          >
            <img :src="duplicateIcon" height="18" alt="duplicate_icon">
          </b-button>
          <b-button
            v-b-tooltip.hover
            :title="'delete' | i18n"
            class="edit-btn close float-none"
            variant="light"
            @click="removeGroup(group.id)"
          >
            <img :src="deleteIcon" height="18" alt="delete_icon">
          </b-button>
        </span>
      </div>
      <div v-if="isOne" class="details-block">
        <span class="details-line">{{ 'Confirmation Checkboxes' | i18n }}: {{ group.isConfirmation ? 'YES' : 'NO' | i18n }}</span>
        <span class="details-line" v-if="group.file">{{ 'File' | i18n }}: {{ group.file.name ? group.file.name : group.file }}</span>
      </div>
    </div>
    <div class="fields-block">
      <draggable group="fields" :list="group.fields" handle=".handle" :force-fallback="true" :options="{ forceFallback: true }">
        <div
          v-for="(field, index) in group.fields"
          :key="`field-${field.id}`"
          :class="`field-container`"
          :style="index === group.fields.length - 1 ? 'border:none' : ''"
        >
          <div :class="`icons-block handle`">
            <img class="field-list-icon" :src="icons[field.type]" v-if="icons[field.type]" />
            <span v-else>{{ `ENTRY_${field.type.toUpperCase()}` | i18n }}</span>
            <span style="font-size: 30px"><BIconJustify /></span>
          </div>
          <div class="inputs-block">
            <Input v-model="field.title" :form-group-id="`name-${field.id}`" placeholder="title" :required="true" />
            <Select v-model="field.type" :options="typesOptions" :form-group-id="`type-${field.id}`" placeholder="entry_type" />
          </div>
          <div :class="`checkboxs-block ${fileAttachment.includes(field.type) ? 'no-file-padding' : ''}`">
            <span v-if="!fileAttachment.includes(field.type)">
              <Checkbox
                v-if="field.type !== ENTRY_TYPES.FEED && !TYPES_LIST_WITHOUT_CHECKBOX.includes(field.type)"
                v-model="field.required"
                :form-group-id="`Required-${field.id}`"
                placeholder="Required"
                :bottom="0"
              />
              <Checkbox
                v-if="!TYPES_LIST_WITHOUT_CHECKBOX.includes(field.type)"
                v-model="field.internal"
                :form-group-id="`Internal-${field.id}`"
                placeholder="Internal"
                :bottom="0"
              />
              <Checkbox
                v-if="!noEditByMobile.includes(field.type)"
                v-model="field.editByMobile"
                :form-group-id="`EditbyMobile-${field.id}`"
                placeholder="Entry on mobile device"
                :bottom="0"
              />
              <Checkbox
                v-if="group.isConfirmation && isOne && !TYPES_LIST_WITHOUT_CHECKBOX.includes(field.type)"
                v-model="field.isConfirmation"
                :form-group-id="`Confirmation-Checkboxes-${field.id}`"
                placeholder="Confirmation Checkboxes"
                :bottom="0"
              />
              <Checkbox
                v-if="attachingFileToEmail.includes(field.type)"
                v-model="field.isAttachFileToEmail"
                :form-group-id="`isAttachFileToEmail-${field.id}`"
                placeholder="Allow attaching the file to an email"
                :bottom="0"
              />
            </span>
            <div
              v-if="(group.isFile && isOne) || fileAttachment.includes(field.type)"
              :class="`file-picker ${fileAttachment.includes(field.type) ? 'no-file-margin' : ''}`"
            >
              <span v-if="field.file" class="d-flex mt-n1">
                <Input
                  :value="field.file.name ? field.file.name : field.file"
                  :viewMode="true"
                  :form-group-id="`File-input-${field.id}`"
                  placeholder="File"
                />
                <div class="pt-3">
                  <b-button
                    v-b-tooltip.hover
                    :title="'Delete file' | i18n"
                    class="close float-none mt-4"
                    variant="light"
                    @click="field.file = null"
                  >
                    <span aria-hidden="true">&times;</span>
                  </b-button>
                </div>
              </span>
              <FileInput
                v-else
                v-model="field.file"
                :form-group-id="`File-${field.id}`"
                placeholder="File"
                :fileExtensions="fileType[field.type] || ''"
                :required="(field.type === ENTRY_TYPES.PICTURE_IN_TEMPLATE || field.type === ENTRY_TYPES.PDF_ATTACHMENT) ? true : false"
              />
            </div>
          </div>
          <span class="actions-block">
            <div>
              <b-button variant="outline-primary" size="sm" v-if="isMobile" @click="removeField(group.id, field.id)">
                <span aria-hidden="true">{{ 'delete' | i18n }}</span>
              </b-button>
              <b-button
                v-b-tooltip.hover
                :title="'delete' | i18n"
                class="close float-none mr-3"
                aria-label="Close"
                variant="light"
                @click="removeField(group.id, field.id)"
                v-else
              >
                <span aria-hidden="true">&times;</span>
              </b-button>
            </div>
            <div :class="`details-action ${isDetailsError(field) ? 'details-action-error' : ''}`" @click="goToFieldDetails(field)">
              <BIconArrowRightShort />
            </div>
          </span>
        </div>
      </draggable>
      <div v-if="!group.fields.length && !isMobile" class="drop-field-text">
        {{ 'Drop field here' | i18n }}
      </div>
      <div v-if="isMobile" class="drop-field-text">
        <b-button variant="primary" size="sm" @click="addField">
          <BIconPlus /> <span> {{ `Add field to` | i18n }} {{ group.name }}</span>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { BIconJustify, BIconArrowRightShort, BIconPlus } from 'bootstrap-vue';
import draggable from 'vuedraggable';

import { ENTRY_TYPES, NO_EDIT_BY_MOBILE, TYPES_LIST_WITHOUT_CHECKBOX } from '../../../../../../../../../constants';
import EditIcon from '../../../../../../assets/icons/Edit_grey.png';
import DuplicateIcon from '../../../../../../assets/icons/Copy_grey.png';
import DeleteIcon from '../../../../../../assets/icons/Delete_grey.png';
import icons from '../icons';
import Input from '../../../../common/input';
import Select from '../../../../common/select';
import Checkbox from '../../../../common/checkbox';
import FileInput from '../../../../common/fileInput';

let timeoutID = null;

export default {
  name: 'TemplateFields',
  components: {
    Input,
    Select,
    BIconJustify,
    draggable,
    Checkbox,
    BIconArrowRightShort,
    FileInput,
    BIconPlus,
  },
  props: {
    group: {
      type: Object,
      default: () => {},
    },
    onChange: {
      type: Function,
      default: () => {},
    },
    editGroupName: {
      type: Function,
      default: () => {},
    },
    duplicateGroup: {
      type: Function,
      default: () => {},
    },
    goToFieldDetails: {
      type: Function,
      default: () => {},
    },
    removeField: {
      type: Function,
      default: () => {},
    },
    removeGroup: {
      type: Function,
      default: () => {},
    },
    isOne: {
      type: Boolean,
      default: false,
    },
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      editIcon: EditIcon,
      duplicateIcon: DuplicateIcon,
      deleteIcon: DeleteIcon,
      icons: icons,
      fileAttachment: [ENTRY_TYPES.PDF_ATTACHMENT, ENTRY_TYPES.PICTURE_IN_TEMPLATE],
      attachingFileToEmail: [
        ENTRY_TYPES.PHOTO,
        ENTRY_TYPES.FILE,
        ENTRY_TYPES.DRAWING,
        ENTRY_TYPES.PICTURE_IN_TEMPLATE,
        ENTRY_TYPES.PDF_ATTACHMENT,
      ],
      noEditByMobile: NO_EDIT_BY_MOBILE,
      typesOptions: Object.keys(ENTRY_TYPES).map((item) => ({
        value: ENTRY_TYPES[item],
        text: this.$translate(`ENTRY_${item}`),
      })),
      fileType: {
        [ENTRY_TYPES.PDF_ATTACHMENT]: 'application/pdf',
        [ENTRY_TYPES.PICTURE_IN_TEMPLATE]: 'image/*',
      },
      ENTRY_TYPES: ENTRY_TYPES,
      TYPES_LIST_WITHOUT_CHECKBOX,
    };
  },
  methods: {
    addField() {
      this.group.fields.push({
        type: ENTRY_TYPES.TEXT,
        name: '',
        require: false,
        editByMobile: true,
        customKey: false,
        id: this.getID(),
      });
    },
    getID() {
      return `${Math.round(Math.random() * 10000)}_${new Date().getTime()}`;
    },
    isDetailsError(item) {
      if (item.type === ENTRY_TYPES.DROPDOWN || item.type === ENTRY_TYPES.MULTIPLE_CHECKBOXES || item.type === ENTRY_TYPES.RADIO_BUTTON) {
        if (!item.values || !item.values.every((i) => i.value)) {
          return true;
        }
        return false;
      }
      if (item.type === ENTRY_TYPES.LIST) {
        return !item.listId;
      }
      if (item.type === ENTRY_TYPES.FORMULA) {
        if (!item.unitName || !item.unitValue || !item.unitFieldName) {
          return true;
        }
        return false;
      }
      if (item.type === ENTRY_TYPES.TEXT_BLOCK) {
        if (!item.mappedValues || !item.mappedValues.every((i) => i.value && i.key)) {
          return true;
        }
        return false;
      }
      return false;
    },
    timeoutForUpdate(fn) {
      if (timeoutID) {
        clearTimeout(timeoutID);
      }
      setTimeout(() => {
        fn();
      }, 500);
    },
  },
};
</script>

<style scoped lang="scss">
.drop-field-text {
  display: flex;
  text-align: center;
  justify-content: center;
  width: 100%;
  top: -36px;
  position: absolute;
}

.draggable-container {
  min-height: 100px;
}

.draggable-container span::before {
  content: ' ';
  background: rgba(230, 230, 230, 0.1);
  justify-content: center;
  align-items: center;
  display: flex;
  border: 1px dashed #e6e6e6;
  height: 50px;
}
.draggable-container span:empty::before {
  padding: 30px;
}
.draggable-container span:not(:empty)::before {
  opacity: 0;
  content: '';
}
.field-list-icon {
  width: 50px;
  height: 50px;
}
.field-container {
  display: flex;
  justify-content: space-between;
  align-content: center;
  align-items: center;
  border-bottom: 1px solid #d9d9d9;
  padding-bottom: 15px;
  margin: 10px 0;
  background: white;
}

::v-deep .text-input-group {
  margin-bottom: 0px;
  width: 45%;
  margin: 0 5px;
}

.no-file-margin {
  margin-top: 0px !important;
}

.no-file-padding {
  padding-top: 0px !important;
}

::v-deep .file-picker {
  margin-top: 15px;
  margin-right: 15px;
  margin-left: -5px;
  width: 100%;
  .text-input-group {
    width: 100% !important;
  }
}

::v-deep .details-action {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background: rgb(34, 129, 254);
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  font-size: 28px;
  margin: 0 10px;
  cursor: pointer;
}
::v-deep .details-action-error {
  background: #dc3545;
}

.icons-block {
  width: 120px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.inputs-block {
  display: flex;
  flex: 3;
  justify-content: space-around;
}

.checkboxs-block {
  display: flex;
  flex: 1;
  padding-top: 2px;
  flex-wrap: wrap;
}

.group-header {
  background: #fafafa;
  width: 100%;
  min-height: 60px;
  padding: 10px 0px;
  color: #5f5f5f !important;
  font-size: 1.5rem !important;
  font-weight: 300;
}

.group-header-box {
  display: flex;
  align-content: center;
  align-items: center;
}

.group-header span {
  padding: 0 15px;
  color: black;
}
.fields-block > div {
  min-height: 50px;
  position: relative;
  padding-bottom: 30px;
}

.edit-btn {
  font-size: 14px;
  margin-left: 20px;
}
.handle {
  cursor: move;
}

.details-block {
  padding-left: 60px;
  display: flex;
  flex-wrap: wrap;
}

.details-line {
  font-size: 15px;
  word-break: break-word;
}

.actions-block {
  display: flex;
  align-items: center;
}

@media (max-width: 1100px) {
  .field-container {
    flex-direction: column;
    align-items: flex-start;
  }

  .icons-block {
    flex-direction: row-reverse;
    width: 100%;
    justify-content: space-between;
    margin: 0 5px;
  }

  .inputs-block {
    flex-direction: column;
    width: 100%;
  }

  .text-input-group {
    width: 100%;
    margin: 10px 5px;
  }

  .actions-block {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin: 15px 5px 0 5px;
    position: relative;
    z-index: 4;
  }

  .checkboxs-block {
    margin: 0 5px;
  }

  .details-action {
    margin: 0;
  }

  .file-picker {
    padding: 0;

    .text-input-group {
      margin: 0;
    }
  }
}
</style>
